export default "__VITE_ASSET__CPaV$Tzk__"